import terminatorErrorMessage from './terminatorErrorMessage'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSeasons, getMainPageData } from '@severed-links/common.redherrings-reducers/terminator'
import { setActiveSeason } from '@severed-links/common.redherrings-reducers/terminatorAdmin'
import { Form, Button, InputGroup } from 'react-bootstrap'
const TerminatorSetActiveSeason = () => {
  const dispatch = useDispatch()
  const { seasons, seasonId } = useSelector(state => state.terminator)
  const [selected, setSelected] = useState('')
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')
  useEffect(() => { dispatch(getSeasons()); dispatch(getMainPageData()) }, [dispatch])
  const value = selected || seasonId || seasons[0]?.seasonId || ''
  const save = async () => {
    setBusy(true)
    try {
      const action = await dispatch(setActiveSeason(value))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to set active season.')
      setMessage(action.payload.message)
      dispatch(getMainPageData())
    } catch (error) { setMessage(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  return <div><InputGroup><Form.Select aria-label='Active Terminator season' disabled={busy} value={value} onChange={event => setSelected(event.target.value)}>{seasons.map(season => <option key={season.seasonId} value={season.seasonId}>{season.seasonName}</option>)}</Form.Select><Button disabled={busy || !value} onClick={save}>Set</Button></InputGroup>{message ? <p role='status'>{message}</p> : null}</div>
}
export default TerminatorSetActiveSeason
